import ApiClient from "~/admin/services/ApiClient";
import queryString from "query-string";

export default class CompaniesApi {
  static list = () => ApiClient.get("companies");
  static paginateValid = (searchName = null, page = null) => {
    let params = {};

    params.searchName = searchName;
    params.page = page;

    return ApiClient.get(
      `companies/paginate-valid?${queryString.stringify(params)}`
    );
  };
  static paginateUnvalided = (page = null) => {
    let params = {};

    params.page = page;
    return ApiClient.get("companies/paginate-unvalided");
  };
  static get = (companyId) => ApiClient.get(`companies/${companyId}`);
  static validate = (companyId) =>
    ApiClient.patch(`companies/${companyId}/validate`);
}
